/**
 * GiftCardBalanceBlock — the big "Current balance" figure plus the
 * credited/debited split underneath it (BON-223 summary card).
 */
import { formatMoney } from '../review/reviewQueueModel';

import { creditsAndDebitsCents } from './giftCardsModel';
import type { GiftCardDetail } from './giftCardTypes';

export function GiftCardBalanceBlock({ card }: { card: GiftCardDetail }) {
  const { creditedCents, debitedCents } = creditsAndDebitsCents(card.transactions);
  return (
    <div>
      <div
        style={{
          fontSize: 10,
          fontWeight: 800,
          letterSpacing: '.06em',
          textTransform: 'uppercase',
          color: 'var(--nb-subtle)',
          marginBottom: 3,
        }}
      >
        Current balance
      </div>
      <div
        className="nb-tabular"
        style={{
          fontSize: 34,
          fontWeight: 800,
          lineHeight: 1,
          color: card.balanceCents === 0 ? 'var(--nb-faint)' : 'var(--nb-primary-2)',
        }}
      >
        {formatMoney(card.balanceCents, card.currency)}
      </div>
      <div
        className="nb-tabular"
        style={{ fontSize: 11.5, color: 'var(--nb-subtle)', marginTop: 6 }}
      >
        {formatMoney(creditedCents, card.currency)} credited ·{' '}
        {formatMoney(debitedCents, card.currency)} debited
      </div>
    </div>
  );
}
